import React from 'react';

export default function QuotationMark() {
  return (
    <svg
      width="78"
      height="49"
      viewBox="0 0 78 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.3">
        <path
          d="M31.2917 13.5743C31.2917 21.2995 29.1299 28.3074 24.8064 34.598C20.4828 40.8885 14.5379 45.6892 6.97173 49L6.16106 46.0203C10.5927 44.1441 14.592 41.2196 18.1589 37.2466C21.7258 33.2737 23.6714 28.6385 23.9957 23.3412C22.4825 24.9966 20.753 26.2658 18.8074 27.1486C16.8619 28.0315 14.8082 28.473 12.6464 28.473C4.21546 28.473 0 24.8311 0 17.5473C0 14.1261 0.756621 11.0912 2.26986 8.44257C3.8912 5.79391 6.05297 3.75225 8.75519 2.31757C11.5655 0.772523 14.7001 0 18.1589 0C22.2663 0 25.4549 1.04842 27.7248 3.14527C30.1027 5.24212 31.2917 8.71847 31.2917 13.5743Z"
          fill="#9CBA6C"
        />
        <path
          d="M78 13.5743C78 21.2995 75.8382 28.3074 71.5147 34.598C67.1911 40.8885 61.2462 45.6892 53.68 49L52.8694 46.0203C57.301 44.1441 61.3003 41.2196 64.8672 37.2466C68.4341 33.2737 70.3797 28.6385 70.704 23.3412C69.1908 24.9966 67.4613 26.2658 65.5157 27.1486C63.5701 28.0315 61.5165 28.473 59.3547 28.473C50.9238 28.473 46.7083 24.8311 46.7083 17.5473C46.7083 14.1261 47.4649 11.0912 48.9782 8.44257C50.5995 5.79391 52.7613 3.75225 55.4635 2.31757C58.2738 0.772523 61.4084 0 64.8672 0C68.9746 0 72.1632 1.04842 74.4331 3.14527C76.811 5.24212 78 8.71847 78 13.5743Z"
          fill="#9CBA6C"
        />
      </g>
    </svg>
  );
}
